import { LayoutPage } from '@/components/hoc';
import { Separator } from '@/components/ui';
import { Outlet } from 'react-router-dom';
import { useTabSelected } from './hooks';
import { TabMenus } from './components';
import { Megaphone } from 'lucide-react';
import routes from '@/lib/routes';

const MarketingPage = () => {
	const { title, tabSelected } = useTabSelected();

	return (
		<LayoutPage
			header={{
				description: 'Gestion des messages admin et des promotions in-app.',
				title: 'Marketing',
			}}
			breadcrumb={{
				title,
				subMenus: [
					{
						href: routes.nav.marketing.messages.getHref(),
						title: 'Marketing',
						menus: (
							[
								tabSelected !== 'promotions' && {
									href: routes.nav.marketing.promotions.getHref(),
									title: 'Promotions',
								},
								tabSelected !== 'messages' && {
									href: routes.nav.marketing.messages.getHref(),
									title: 'Messages',
								},
								tabSelected !== 'bulk-notifications' && {
									href: routes.nav.marketing.bulkNotifications.getHref(),
									title: 'Notifications push',
								},
							] as any[]
						).filter(l => l),
					},
				],
			}}
			icon={Megaphone}
		>
			<div className="flex flex-col space-y-3">
				<TabMenus />
				<Separator className="bg-muted" />
				<Outlet />
			</div>
		</LayoutPage>
	);
};

export default MarketingPage;
